import { Migration_5_Indexes } from './Migration_5_Indexes';
import { Migration_6_Invoice_Search } from './Migration_6_Invoices_filter';
import { Migration_7_Indexes } from './Migration_7_Indexes';

export const migrations = [
  Migration_5_Indexes,
  Migration_6_Invoice_Search,
  Migration_7_Indexes,
];
